import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import "../../stylesheet/forms.css";
import ContextApi from "../../context/ContextApi";
import PatientSearch from "../patient/utils/PatientSearch";
import ToastContext from "../../context/toasterContex";
import AddToInvoice from "./forms/AddItemModal";
import Dropdown from "./forms/Dropdown";

const InvoiceForm = ({ updateFormData, proceed }) => {
  const { formData } = useContext(ContextApi);
  const { toast } = useContext(ToastContext);
  const [personnel_type, setPersonelType] = useState(null); // 'company || 'patient'
  const [currentPatient, setCurrentPatient] = useState(null);
  // const [clientType, setClientType] = useState(null);
  const [itemDetails, setItemDetails] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [editingMode, setEditingMode] = useState(false);
  const [currEditable, setCurrEditable] = useState(null);
  const navigate = useNavigate();

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if (name) {
      setCurrentPatient(value);
      updateFormData({
        ["user"]: null,
      });
    }
    updateFormData({
      ...formData,
      [name]: value,
    });
  };
  const gotSelectedPatient = (data) => {
    setCurrentPatient(data);
  };
  const handleNext = () => {
    updateFormData({
      ...formData,
      user: currentPatient,
      items: itemDetails,
      personnel_type,
      client_type : formData?.client_type ?? 'patient' 
    });
    if (currentPatient) {
      proceed();
    } else {
      toast.error("Please complete the form to proceed", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };
  const gotAction = (mode, data, index) => {
    if (mode === "delete") {
      const newArr = [...itemDetails].splice(index, 1);
      setItemDetails(newArr);
    } else if (mode === "edit") {
      setCurrEditable({ mode, data, index });
      setEditingMode(true);
      setShowAddModal(true);
    }
  };
  useEffect(() => {
    if (formData?.user) {
      setPersonelType(formData?.personnel_type);
      setCurrentPatient(formData?.user);
      setItemDetails(formData?.items);
    }
  });

  return (
    <div className="step_form">
      {showAddModal && (
        <AddToInvoice
          edit={editingMode}
          item={currEditable?.data}
          onClose={() => setShowAddModal(false)}
          updateItem={(newData) => {
            const newDetails = [...itemDetails];
            newDetails[currEditable?.index] = { ...newData };
            setItemDetails(newDetails);
            setShowAddModal(false);
          }}
          addNewItem={(data) => {
            console.log(data, itemDetails)
            const newDetails =  [ ...itemDetails, data];
            setItemDetails(newDetails);
            setShowAddModal(false);
          }}
        />
      )}
      {!personnel_type && (
        <div className="flex justify-center my-20 gap-10">
          <div className="my-8">
            <div
              className="border border-grey-100 w-full md:w-[220px] mb-3 rounded-[5px] p-2 capitalize relative cursor-pointer"
              key="patient"
              onClick={(e) => setPersonelType("patient")}
            >
              {personnel_type == "patient" && (
                <div className="rounded-full w-4 h-4 bg-primary text-white absolute right-2">
                  <div className="flex justify-center align-middle text-[11px]">
                    {"✓"}
                  </div>
                </div>
              )}
              <div className="font-bold">
                <div className="flex justify-between gap-2">
                  <p> </p>
                </div>
              </div>
              <div className="text-center mx-auto">
                <h2 className="">For Patient</h2>
              </div>
            </div>
          </div>
          <div className="my-8">
            <div
              className="border border-grey-100 w-full md:w-[220px] mb-3 rounded-[5px] p-2 capitalize relative cursor-pointer"
              key="company"
              onClick={(e) => setPersonelType("company")}
            >
              {personnel_type == "company" && (
                <div className="rounded-full w-4 h-4 bg-primary text-white absolute right-2">
                  <div className="flex justify-center align-middle text-[11px]">
                    {"✓"}
                  </div>
                </div>
              )}
              <div className="font-bold">
                <div className="flex justify-between gap-2">
                  <p> </p>
                </div>
              </div>
              <div className="text-center mx-auto">
                <h2 className="">For Partner/Company</h2>
              </div>
            </div>
          </div>
        </div>
      )}
      {personnel_type && (
        <>
          {personnel_type !== "company" ? (
            <>
              <div className="step_input">
                <label htmlFor="name">Patient name</label>
                {currentPatient ? (
                  <>
                    <div className="w-full flex justify-center text-center">
                      <span className="p-1 capitalize cursor-pointer">
                        <span className=" text-primary font-medium text-2xl">
                          <span> </span>
                          {currentPatient?.patientName ||
                            formData.user.patientName}
                        </span>
                      </span>
                    </div>
                  </>
                ) : (
                  <div className="text-center w-full">
                    <p className="mt-5">
                      Please enter an existing Patient's name to create an
                      invoice
                    </p>
                    <div className="w-[500px] m-auto">
                      <PatientSearch
                        className="mt-5 text-left"
                        SelectedPatient={gotSelectedPatient}
                      />
                    </div>
                    <p className="mt-10">Or rather</p>

                    <p>Click button below to create a new Patient</p>
                    <button
                      onClick={() => {
                        localStorage.setItem("patientEditMode", false);
                        navigate("/patients/new-patient");
                      }}
                      className="active bg-primary p-3 px-5 mt-5 rounded-full text-white"
                    >
                      Create New Patient
                    </button>
                  </div>
                )}
                {
                  <>
                    {currentPatient && (
                      <div className="w-full flex justify-center">
                        <button
                          className="border-primary border text-primary mb-4 p-2 w-36 rounded ml-3"
                          onClick={(e) => {
                            e.preventDefault();
                            setCurrentPatient(null);
                          }}
                        >
                          Change Patient
                        </button>
                      </div>
                    )}
                  </>
                }
              </div>
            </>
          ) : (
            <>
              <div className="step_input">
                <label htmlFor="name">Company Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData?.name || ""}
                  onChange={handleInputChange}
                  className="w-full border-2 border-gray-300 p-2 rounded-md"
                  required
                />
              </div>
            </>
          )}
          {personnel_type !== "patient" && (
            <div className="step_input">
              <label htmlFor="brand">Client type</label>
              <select
                name="client_type"
                id="client_type"
                onChange={handleInputChange}
                value={formData?.client_type || ""}
              >
                <option disabled value={""}>
                  Select client type
                </option>
                <option value="provider-hospital">Provider - Hospital</option>
                <option value="provider-pharmacy"> Provider - Pharmacy</option>
                <option value="provider-laboratory">
                  Provider - Laboratory
                </option>
                <option value="provider-diagnostic-imaging">
                  Provider - Diagnostic Imaging
                </option>
                <option value="provider-others">Provider - Others</option>
                <option value="payer-health-insurance">
                  Payer - Health Insurance
                </option>
                <option value="payer-employer"> Payer - Employer</option>
                <option value="payer-donor_ngo"> Payer - Donor & NGO</option>
                <option value="payer-government"> Payer - Government</option>
                <option value="payer-others">Payer - Others</option>
              </select>
            </div>
          )}

          {/* {drugs.length ?  */}
          {itemDetails && itemDetails.length ? (
            <div className=" my-5">
              <table className="drug_table">
                <thead>
                  <tr>
                    <th>
                      <div className="flex">
                        <div></div>
                        <span className="">S/N</span>
                      </div>
                    </th>
                    <th>
                      {" "}
                      <div>Amount</div>{" "}
                    </th>
                    <th>Responsible Dept.</th>
                    <th>Description.</th>
                    <th>
                      <div className="text-right">
                        {
                          <button
                            type="button"
                            className={`bg-primary text-sm text-white p-[0.4rem] rounded " `}
                            onClick={() => setShowAddModal(true)}
                          >
                            Add Item
                          </button>
                        }
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {itemDetails.map((invoiceItem, index) => (
                    <tr className="p-4" key={index}>
                      <td className="p-4">
                        <div className="flex items-center align-middle">
                          <input
                            type="checkbox"
                            id={`${index}`}
                            data={invoiceItem}
                          />
                          <div className="ml-4">#{index + 1}</div>
                        </div>
                      </td>
                      <td className="p-4">{invoiceItem.amount}</td>
                      <td className="dos p-4">
                        {invoiceItem.responsible_dept}
                      </td>
                      <td className="dos p-4 truncate">
                        {invoiceItem.description}
                      </td>
                      <td className="p-4">
                        <Dropdown
                          className="text-right"
                          index={index}
                          invoiceItemsData={invoiceItem}
                          getAction={gotAction}
                        />
                        {/* setDrugsData={setDrugs}
                        setCurr={setCurrentDrug} setindex={setDrugIndex} setisAddingDrug={setisAddingDrug}  */}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <>
              <p className="text-center text-gray-500">
                Please click below to Add items
              </p>
              {
                <button
                  type="button"
                  className={`bg-primary text-sm text-white p-[0.4rem] rounded " `}
                  onClick={() => setShowAddModal(true)}
                >
                  Add Item
                </button>
              }
            </>
          )}

          {itemDetails && itemDetails.length > 0 && currentPatient && (
            <div className="w-full flex justify-end">
              <button
                type="submit"
                onClick={handleNext}
                className="document_button bg-primary"
              >
                Continue
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default InvoiceForm;
